import axios from 'axios';

const apiNoHeaders = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API
});

export default apiNoHeaders;